module.exports = __webpack_public_path__ + "static/media/InactivePrevButton.be738d52.svg";